export const DRAWING_EVALUATION_ERROR =
{
    processingError: "There's no score evaluated for this drawing. Please try again.",
    serverConnectionError: "Connection to the server is lost. Please make check your internet connection and try again."
}

export const colors = {
    colorNeutral0: "#f7f7f7",
    colorNeutral100: "#b8b8b8",
    colorNeutral400: "#5d5e5e",
    colorNeutral500: "#4a4b4b",
    colorNeutral800: "#131212",
    colorNeutral900: "#020202",
    colorNeutral1000: "#000000",
    orange: "#ff3c00",
    red: "#a80000",
    lightBlue: "#06b3cf",
    brandColor: "#06b3cf"
};
